import { useContext } from "react";
import { DrillDownContext } from "./DrillDownContext";

export function useDrillDownContext() {
  const context = useContext(DrillDownContext);
  if (!context) {
    throw new Error(
      "useDrillDownContext must be used within a DrillDownContextProvider",
    );
  }
  return context;
}
